export const ArrowRight = ({ fill = 'white', fillOpacity = '0.5' }) => (
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.195262 9.47132C0.455612 9.73167 0.877722 9.73167 1.13807 9.47132L5.13807 5.47132C5.2631 5.3463 5.33334 5.17673 5.33334 4.99992C5.33334 4.82311 5.2631 4.65354 5.13807 4.52851L1.13807 0.528514C0.877722 0.268164 0.455612 0.268165 0.195262 0.528514C-0.065087 0.788864 -0.0650869 1.21097 0.195263 1.47132L3.72386 4.99992L0.195263 8.52851C-0.0650869 8.78886 -0.0650871 9.21097 0.195262 9.47132Z"
      fill={fill}
      fillOpacity={fillOpacity}
    />
  </svg>
);
